export default __webpack_public_path__ + "static/media/Pilgrim's Boots of the Crumbling Tower.890097e0.jpg";